<template>
    <div class="post-block" v-if="visible && postData">    
        <router-link 
            :to="linkUrl"
            ref="link">   
            <div class="inner" v-if="postImage">
                <wpImage 
                    :data="postImage" 
                    :size="imageSize"
                    class="post-image-bg"
                    background
                    lazy
                />
                <div class="img-overlay"></div>
                <h3 class="post-title">{{postData.title.rendered}}</h3>
            </div>
            <div v-else class="loader">
                <div class="image"></div>
            </div>
        </router-link>
    </div>
    <postBlockLoader v-observe-visibility="{
        callback: checkVisibility,
        intersection: {
            rootMargin: '100px 0px 0px 0px',
            threshold: 0
        }
        }" v-else />
</template>

<script>

import postBlockLoader from '@/components/loaders/postBlock'
import wpLink from '@/components/navigation/WpLink'
import wpImage from '@/components/elements/WpImage'

import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'post-block',
    props: ['id', 'type','size'],
    components: {
        postBlockLoader,
        wpLink,
        wpImage
    },
    data(){
        return{
            visible: false,
            loading: false,
            homeUrl: window.WPVUE.home_url,
        }
    },
    computed: {
        ...mapGetters([
            'getPostById',
            'getPlaceholder'
        ]),
        imageSize(){
            return this.size || 'medium'
        },
        postData(){
            const postType = this.type || 'post'
            const postId = this.id
            let post = this.getPostById( postId )
            
            return post
        },
        linkUrl(){
			if(this.postData.link && this.postData.link !== ''){
				return this.postData.link.replace(this.homeUrl, '');
			}else return '';
        },
        postImage(){
            const type = this.postData.type
            return (this.postData && this.postData.featured_image_src) ? 
                this.postData.featured_image_src : 
                this.getPlaceholder(type);
        }
    },
    mounted(){
    },
    methods: {
        checkVisibility(vis, el){
            if(vis && !this.visible) {
                this.visible = true
            }
        }
    },
}
</script>